import { ITaggingFlowOption } from 'interfaces/tagging/ITaggingFlowOption';
import { CallTypes } from '@trackman/baseball-shared-components';

export const AutomaticOptions: ITaggingFlowOption[] = [
  {
    displayName: 'Automatic Ball',
    value: CallTypes.BallCalled,
    hotkeyCode: 65,
    hotkeyDisplay: 'A',
  },
  {
    displayName: 'Automatic Strike',
    value: CallTypes.StrikeCalled,
    hotkeyCode: 85,
    hotkeyDisplay: 'U',
  },
];
